import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Kontakt from './pages/Kontakt';
import Clubhaus from './pages/Clubhaus';
import History from './pages/History';
import Partys from './pages/Partys';
import Legal from './pages/Legal';
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-black text-white flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/clubhaus" element={<Clubhaus />} />
              <Route path="/history" element={<History />} />
              <Route path="/partys" element={<Partys />} />
              <Route path="/impressum" element={<Legal type="impressum" />} />
              <Route path="/datenschutz" element={<Legal type="datenschutz" />} />
            </Routes>
          </AnimatePresence>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;